import http from "../utils/http";
import { Specialty } from "./types";

const getPreviouslyUsedProviders = async () => {
  try {
    const response = await http.get("appointments/patient/previous-providers");
    if (response.status === 200) {
      return response.data;
    }
    // throw response.error;
  } catch (err) {
    return err;
  }
};

export const getSinglePatientPrescriptiontDetails = async (
  prescriptionId: number
) => {
  try {
    const response = await http.get(`patients/prescription/${prescriptionId}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};

export const getPatientPrescriptionsList = async () => {
  try {
    const response = await http.get("prescriptions/patient");
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error;
  }
};

type ParamsProps = {
  specialty: Specialty;
  dependentId?: string;
};
export const getUsedProvidersBasedOnSpecialty = async ({
  specialty,
  dependentId
}: ParamsProps) => {
  const queryString = dependentId
    ? `appointments/patient/previous-providers?specialty=${specialty}&dependentId=${dependentId}`
    : `appointments/patient/previous-providers?specialty=${specialty}`;
  try {
    const response = await http.get(queryString);
    if (response.status === 200) {
      return response.data;
    }
    // throw response.error;
  } catch (err) {
    return err;
  }
};

export const updatePatientDetails = async (params: any) => {
  try {
    const response = await http.get("/patients/details", { params });
    if (response.status === 200) {
      return response.data;
    }
    // throw response.error;
  } catch (err) {
    return err;
  }
};

export const getPatientBookedProviders = async () => {
  try {
    const response = await http.get("patients/providers/booked");
    if (response.status === 200) {
      return response.data.patientsProviders;
    }
  } catch (error) {
    return error;
  }
};

export { getPreviouslyUsedProviders };
